import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { deepClone } from '../../../../../helpers/objectHelper';
import { backgroundWithImageHandler } from './BackgroundImageWithText.handler';
import { emailActions } from '../../../../../store/actions/cms/email/email.action';
import TextWrapper from '../../components/TextWrapper';

const LargeHeaderImage = (props) => {
    const [mediaVaultOpen, openMediaVault] = useState(false)
    const [isCropping, toggleCropper] = useState(false)
    const [editing, toggleText] = useState(false)
    const { content, style } = props.element;
    const { template, element, selectedElement } = props;


    const setImage = (source, openCropper = true) => {
        const { element, dispatch } = props;
        const updatedElement = deepClone(element);
        try {
            updatedElement.style.elementProps.source = source;
        } catch (error) {
            console.log('ERR: COULD NOT SET IMAGE')
        }
        updatedElement.content = backgroundWithImageHandler.elementEditor(updatedElement.style, null);
        dispatch(emailActions.updateEmailElement(updatedElement, null, true, props.inherit));
        if (openCropper) toggleCropper(true)
    }
    const textOnChange = (text) => {
        const { element, dispatch } = props;
        const updatedElement = deepClone(element);
        try {
            updatedElement.style.elementProps.text = text;
        } catch (error) {
            console.log('ERR: COULD NOT SET TEXT')
        }
        updatedElement.content = backgroundWithImageHandler.elementEditor(updatedElement.style, null);
        dispatch(emailActions.updateEmailElement(updatedElement, null, true, props.inherit));
    }
    const onCrop = (value) => {
        setImage(value, false);
        toggleCropper(false)
    }
    const toggleMediaVault = (show) => {
        openMediaVault(show)
    }
    const toggleTextEdit = (show) => {
        toggleText(show)
    }
    return (
        <React.Fragment>
            <tr>
                
                 <td className="email-image-wrapper" style={{
                    textAlign: 'center',
                    position: 'relative',
                    backgroundImage: `url(${element.style.elementProps.source})`,
                    backgroundColor: '#222222',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    maxWidth: '680px',
                    width: '680px',
                    height: '180px'
                }}>
                    <div>
                        <table align="center" role="presentation" border="0" cellSpacing="0" cellPadding="0" width="500">
                            <tr>
                                <td width="500">
                                    <table role="presentation" border="0" cellPadding="0" cellSpacing="0" width="100%" style={{
                                        maxWidth: '500px',
                                        margin: 'auto'
                                    }} >
                                        <tbody>
                                            <tr>
                                                <td style={element.style.textStyle}>
                                                    <TextWrapper
                                                        element={element}
                                                        contentId={element.id}
                                                        text={element.style.elementProps.text}
                                                        textOnChange={textOnChange}
                                                    />
                                                    {/*             <p style={{ margin: 0 }}>{element.style.elementProps.text}</p> */}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr >
        </React.Fragment >
    )
}
function mapStateToProps(state) {
    return {
        template: state.template.template,
        inherit: state.email.inherit,
        selectedElement: state.email.selectedElement
    };
}

export default connect(mapStateToProps)(LargeHeaderImage);